// dataService.js
import api from "../../../utils/ApiConfig";

// ✅ Récupérer toutes les commandes des fournisseurs
const fetchAllFournisseurCommandes = async (nbr, termSearch, nbPage, status, livreurId, deliveryDate, enRetard, clientType) => {
  try {
    const params = {
      page: nbr,
      search: termSearch,
      nbpage: nbPage,
      status: status,
      livreur_id: livreurId,
      delivery_date: deliveryDate,
      en_retard: enRetard ? 'true' : undefined,
      client_type: clientType,
    };

    const filteredParams = Object.entries(params)
      .filter(([_, value]) => value !== undefined && value !== "" && value !== null)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join("&");

    const response = await api.get(`/fo/ShowAllCommandeFournisseur?${filteredParams}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

// ✅ Récupérer toutes les commandes pour le calendrier (sans pagination)
const fetchAllFournisseurCommandesForCalendar = async (termSearch, status, livreurId, deliveryDate, enRetard, clientType) => {
  try {
    const params = {
      search: termSearch,
      status: status,
      livreur_id: livreurId,
      delivery_date: deliveryDate,
      en_retard: enRetard ? 'true' : undefined,
      client_type: clientType,
    };

    const filteredParams = Object.entries(params)
      .filter(([_, value]) => value !== undefined && value !== "" && value !== null)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join("&");

    const response = await api.get(`/fo/ShowAllCommandeFournisseurForCalendar?${filteredParams}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching calendar data:", error);
    throw error;
  }
};

// ✅ Fonction pour récupérer les demandes depuis Laravel
const fetchLaravelDemandes = async () => {
  try {
    const response = await api.get(`/commandes/demandes`); // Assure-toi que cet endpoint existe dans Laravel
    return response.data?.data || [];
  } catch (error) {
    console.error("Erreur lors de la récupération des demandes Laravel :", error);
    return [];
  }
};

// ✅ Récupérer les commandes d’un fournisseur (à compléter si utilisé)
const fetchFournisseurCommandes = async (nbr, termSearch) => {
  try {
    const response = await api.get(`/...?page=${nbr}${termSearch}`);
  } catch (error) {
    console.error("Error fetching Orders Fournisseur data:", error);
    throw error;
  }
};

// ✅ Ajouter une commande fournisseur
const CreateFournisseurCommande = async (orderFournisseur) => {
  try {
    const response = await api.post(`/fo/addCommandeFournisseur`, orderFournisseur);
    return response;
  } catch (error) {
    console.error("Error saving Order Fournisseur data:", error);
    throw error;
  }
};

// ✅ Mettre à jour une commande fournisseur
const updateFournisseurCommande = async (orderId, orderData) => {
  try {
    const response = await api.post(`/fo/updateCommandeFournisseur/${orderId}`, orderData);
    return response;
  } catch (error) {
    console.error("Error updating Order Fournisseur data:", error);
    throw error;
  }
};

// ✅ Récupérer tous les livreurs
const FetchAllLivreur = async () => {
  try {
    const response = await api.get(`/bo/getAllLivreur`);
    return response;
  } catch (error) {
    console.error("Error to get list livreur data:", error);
    throw error;
  }
};

// ✅ Récupérer tous les fournisseurs
const FetchListFournisseur = async () => {
  try {
    const response = await api.get(`/bo/getAllFournisseur`);
    return response;
  } catch (error) {
    console.error("Error to get list fournisseur data:", error);
    throw error;
  }
};

// ✅ Récupérer tous les particuliers
const FetchListParticuliers = async () => {
  try {
    const response = await api.get(`/bo/getAllParticuliers`);
    return response;
  } catch (error) {
    console.error("Error to get list particuliers data:", error);
    throw error;
  }
};

// ✅ Récupérer toutes les entreprises
const FetchListEntreprises = async () => {
  try {
    const response = await api.get(`/bo/getAllEntreprises`);
    return response;
  } catch (error) {
    console.error("Error to get list entreprises data:", error);
    throw error;
  }
};

// ✅ Récupérer une commande fournisseur par ID
const GetOneCommandeById = async (idcommande) => {
  try {
    const response = await api.get(`/fo/ShowOneCommandeFournisseur/${idcommande}`);
    return response.data;
  } catch (error) {
    console.error("Error to get Order fournisseur data:", error);
    throw error;
  }
};

// ✅ Récupérer toutes les dates de livraison disponibles
const fetchAvailableDeliveryDates = async () => {
  try {
    const response = await api.get(`/fo/getAvailableDeliveryDates`);
    return response.data;
  } catch (error) {
    console.error("Error fetching available delivery dates:", error);
    throw error;
  }
};

// ✅ Récupérer la disponibilité des livreurs pour une date donnée
const fetchLivreurDisponibilite = async (dateLivraison) => {
  try {
    const response = await api.get(`/livreurs/disponibilite`, {
      params: {
        date: dateLivraison
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching livreur disponibilite:", error);
    throw error;
  }
};

// ✅ Récupérer les images POD (Proof of Delivery) d'une commande
const fetchPODImages = async (commandeId) => {
  try {
    const response = await api.get(`/fo/commande/${commandeId}/pod-images`);
    return response.data;
  } catch (error) {
    console.error("Error fetching POD images:", error);
    throw error;
  }
};

// ✅ Ajouter une image POD
const uploadPODImage = async (commandeId, imageFile) => {
  try {
    const formData = new FormData();
    // Le backend attend un tableau 'images', on utilise images[0] pour le premier élément
    formData.append('images[0]', imageFile);
    const response = await api.post(`/fo/commande/${commandeId}/pod-images`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error uploading POD image:", error);
    throw error;
  }
};

// ✅ Supprimer une image POD
const deletePODImage = async (commandeId, imageId) => {
  try {
    const response = await api.delete(`/fo/pod-images/${imageId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting POD image:", error);
    throw error;
  }
};

// ✅ Exportation des fonctions
export {
  fetchFournisseurCommandes,
  CreateFournisseurCommande,
  updateFournisseurCommande,
  FetchAllLivreur,
  FetchListFournisseur,
  FetchListParticuliers,
  FetchListEntreprises,
  fetchAllFournisseurCommandes,
  fetchAllFournisseurCommandesForCalendar,
  GetOneCommandeById,
  fetchLaravelDemandes,
  fetchAvailableDeliveryDates,
  fetchLivreurDisponibilite,
  fetchPODImages,
  uploadPODImage,
  deletePODImage
};
